module.exports = __webpack_public_path__ + "img/1494735519.364cfab7.jpg";